import React, { useEffect } from 'react';
import { MyCarsWrapper } from './LandingPage.styles';
import VehicleCard from './vehicle-card';
import { useDualEventTracking } from '../../utils/useDualEventTracking';

function LandingPage() {
  const { trackEvent } = useDualEventTracking();
  useEffect(() => trackEvent('view_my_cars'), []);

  return (
    <MyCarsWrapper>
      <VehicleCard />
    </MyCarsWrapper>
  );
}

export default LandingPage;
